import { Avatar, Button, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { BlueRequest } from 'Images';

interface IReferralRequest {
  onClick: Function;
}

export const ReferralRequest = ({ onClick }: IReferralRequest) => {
  const isDesktop = useIsDesktop();
  return (
    <Button
      onClick={(event: React.MouseEvent) => {
        event.stopPropagation();
        onClick();
      }}
      sx={{
        p: isDesktop ? '10px 16px' : '6px 12px',
        height: 'fit-content',
        borderRadius: '100px',
        border: '1px solid',
        borderColor: 'primary.shade_400',
        display: 'flex',
        gap: '6px',
        whiteSpace: 'nowrap',
      }}
    >
      <Avatar alt='' src={BlueRequest} sx={{ width: '20px', height: '20px' }} />
      <Typography variant='body5'>
        {Dictionary[DICTIONARY.Suppliers].resultPage.therapy.request}
      </Typography>
    </Button>
  );
};
